import { useEffect, useState } from "react";
import "assets/scss/themes.scss";
import Route from "Routes/Index";

// CSS hide all the horizontal & Vertical ScrollBars
// import "./App.css"

import { useDispatch } from "react-redux";
import { loginSuccess } from "slices/auth/login/reducer";

const App = () => {
  const dispatch = useDispatch<any>();

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const parsedUser = JSON.parse(authUser);
      dispatch(loginSuccess(parsedUser)); // Rehydrate user into Redux
    }
  }, []);

  return (
    <>
      <Route />
    </>
  );
};

export default App;
